import {
  fetchChatsGetStarredChatsDesktop,
  IChatsGetStarredChatsDesktopRequest,
  TChatsGetStarredChatsDesktopResponse,
} from '../repositories/chats/v1/chats/get-starred-chats-desktop';
import { TContext } from '../types/context';

type TFetchStarredChatsParams = {
  parameters: IChatsGetStarredChatsDesktopRequest;
  cookies?: string;
};

export async function fetchStarredChats(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchStarredChatsParams,
) {
  try {
    const { response, statusCode }: TChatsGetStarredChatsDesktopResponse = await fetchChatsGetStarredChatsDesktop({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      return null;
    }

    return response.chats || [];
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchStarredChats.ts [fetchStarredChats]',
      message: 'Не удалось получить список важных чатов',
    });

    return null;
  }
}
